import { format, unwrapFunctionStore } from 'svelte-i18n';

import { calculateHeightToBottom } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const sigEditorA = {
  element: '.editor .source',
  popover: {
    description: $format('label.TOURS.STUDIO.EDIT.SIG_EDITOR.A.DESCRIPTION'),
    side: 'top',
    align: 'center',
    onPrevClick: () => {
      const editHtmlButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div > div > button'
      );

      if (editHtmlButton) {
        editHtmlButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 50);
      }
    }
  }
};

export const sigEditorB = {
  element: '.editor .source',
  popover: {
    description: $format('label.TOURS.STUDIO.EDIT.SIG_EDITOR.B.DESCRIPTION'),
    side: 'right',
    align: 'center'
  }
};
